import { LOCAL_STORAGE_HVM_CONFIG, LOCAL_STORAGE_HVM_CONFIG_DATE } from "@/lib/Constant";

export const getToday = () => {
  return new Date().toISOString().split('T')[0];
}

export const getConfigDate = () => {
  return localStorage.getItem(LOCAL_STORAGE_HVM_CONFIG_DATE);
}

export const getConfig = () => {
  if(localStorage.getItem(LOCAL_STORAGE_HVM_CONFIG) !== null && localStorage.getItem(LOCAL_STORAGE_HVM_CONFIG) !== undefined){
    return JSON.parse(localStorage.getItem(LOCAL_STORAGE_HVM_CONFIG));
  }else{
    return null;
  }
}

export const setConfig = (config) => {
  localStorage.setItem(LOCAL_STORAGE_HVM_CONFIG_DATE, getToday());
  localStorage.setItem(LOCAL_STORAGE_HVM_CONFIG, JSON.stringify(config));
}

// 플랫폼 정보 업데이트 함수 추가
export const updatePlatformInfo = (platformInfo) => {
  const currentConfig = getConfig();
  
  if (currentConfig) {
    // 기존 설정에 플랫폼 정보 추가/업데이트
    const updatedConfig = {
      ...currentConfig,
      platform: {
        platformType: platformInfo.platformType || '',
        platformUser: platformInfo.platformUser || '',
        platformGroup: platformInfo.platformGroup || '',
        platformSeq: platformInfo.platformSeq || ''
      }
    };
    setConfig(updatedConfig);
    console.log('플랫폼 정보 업데이트:', updatedConfig.platform);
  } else {
    // 설정이 없으면 새로 생성
    const newConfig = {
      platform: {
        platformType: platformInfo.platformType || '',
        platformUser: platformInfo.platformUser || '',
        platformGroup: platformInfo.platformGroup || '',
        platformSeq: platformInfo.platformSeq || ''
      }
    };
    setConfig(newConfig);
    console.log('새 플랫폼 정보 생성:', newConfig.platform);
  }
}

// 플랫폼 정보 조회 함수들 추가
export const getPlatformInfo = () => {
  const config = getConfig();
  return config && config.platform ? config.platform : {
    platformType: '',
    platformUser: '',
    platformGroup: '',
    platformSeq: ''
  };
}

export const getPlatformType = () => {
  const platformInfo = getPlatformInfo();
  return platformInfo.platformType || '';
}

export const getPlatformUser = () => {
  const platformInfo = getPlatformInfo();
  return platformInfo.platformUser || '';
}

export const getPlatformGroup = () => {
  const platformInfo = getPlatformInfo();
  return platformInfo.platformGroup || '';
}

export const getPlatformSeq = () => {
  const platformInfo = getPlatformInfo();
  return platformInfo.platformSeq || '';
}

export const getBranchUuid = () => {
  console.log(getConfig);
  if(getConfig() != null){
    return getConfig().branch.branchUuid;
  }else{  
    return null;
  }
}

export const getBrandServiceType = () => {
  if(getConfig() != null){
    return getConfig().brandServiceType;  
  }else{
    return '';
  }
}

